import o from "clsx";
import e from "react";
import { s as C } from "../../../../../RideIcon.module-BjMwOP4j.mjs";
function c({
  size: t = "small",
  accessibilityTitle: r = "ricon soat light",
  className: n,
  "data-testid": a
}) {
  const l = () => o(n, C["ride-icon"], {
    [C[`size-${t}`]]: t
  });
  return /* @__PURE__ */ e.createElement("div", { className: l(), "data-testid": a }, /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      stroke: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    r && /* @__PURE__ */ e.createElement("title", null, r),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M45.1474 53.6225C44.7589 54.3442 44.1815 54.9467 43.4769 55.3655C42.7723 55.7843 41.9671 56.0036 41.1474 56H20.9999C20.1802 56.0039 19.3749 55.7847 18.6703 55.3659C17.9656 54.9471 17.3882 54.3444 16.9999 53.6225L6.51493 34.1225C6.16199 33.4698 5.97718 32.7395 5.97718 31.9975C5.97718 31.2555 6.16199 30.5252 6.51493 29.8725L16.9999 10.3725C17.3889 9.65152 17.9666 9.04989 18.6712 8.63198C19.3758 8.21406 20.1807 7.99561 20.9999 8H41.1474C41.9671 7.99637 42.7723 8.21569 43.4769 8.63448C44.1815 9.05327 44.7589 9.65577 45.1474 10.3775L54.6224 28H59.1624V27.9825L48.6774 8.4825C47.9489 7.1275 46.8668 5.9952 45.5462 5.20593C44.2256 4.41667 42.7159 3.99993 41.1774 4H20.9999C19.4615 3.99993 17.9517 4.41667 16.6312 5.20593C15.3106 5.9952 14.2285 7.1275 13.4999 8.4825L3.01493 27.9825C2.34909 29.2169 2.00049 30.5975 2.00049 32C2.00049 33.4025 2.34909 34.7831 3.01493 36.0175L13.4999 55.5175C14.2285 56.8725 15.3106 58.0048 16.6312 58.7941C17.9517 59.5833 19.4615 60.0001 20.9999 60H41.1474C42.6859 60.0001 44.1956 59.5833 45.5162 58.7941C46.8368 58.0048 47.9189 56.8725 48.6474 55.5175L51.6349 50H47.0949L45.1474 53.6225Z",
        fill: "url(#paint0_linear_1437_209)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.25 40.6323H19.5C19.555 41.6098 20.37 42.1848 21.645 42.1848C22.8275 42.1848 23.3625 41.7023 23.3625 40.9648C23.3625 40.3548 22.955 40.0223 21.7 39.7823L19.7 39.4123C17.5025 39.0073 16.2625 37.8048 16.2625 35.9398C16.2625 33.4998 18.3325 31.8198 21.365 31.8198C24.3975 31.8198 26.5 33.4998 26.5 36.0498H23.25C23.175 35.1998 22.5 34.6448 21.29 34.6448C20.1825 34.6448 19.5725 35.1073 19.5725 35.7723C19.5725 36.2523 19.9225 36.5848 21.16 36.8073L23.16 37.1773C25.47 37.6023 26.66 38.8398 26.66 40.7798C26.66 43.2798 24.7375 45.0473 21.485 45.0473C18.2325 45.0473 16.25 43.3098 16.25 40.6323ZM27.9125 38.4323C27.9125 34.4973 30.7775 31.8198 34.51 31.8198C38.2425 31.8198 41.1075 34.4973 41.1075 38.4323C41.1075 42.3673 38.25 45.0473 34.5 45.0473C30.75 45.0473 27.9125 42.3673 27.9125 38.4323ZM37.6625 38.4323C37.6625 36.3273 36.3325 34.9323 34.5025 34.9323C32.6725 34.9323 31.3425 36.3373 31.3425 38.4323C31.3425 40.5273 32.6725 41.9323 34.5025 41.9323C36.3325 41.9323 37.67 40.5398 37.67 38.4323H37.6625ZM51.045 44.8998L50.2675 42.4248H45.5625L44.7875 44.8998H41.3675L45.75 31.9673H50.1675L54.5475 44.8998H51.045ZM46.425 39.6498H49.4L47.9225 34.9398L46.425 39.6498ZM63.75 31.9673V35.0698H60.33V44.8998H56.9675V35.0698H53.5475V31.9673H63.75Z",
        fill: "url(#paint1_linear_1437_209)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_1437_209",
        x1: "2.00049",
        y1: "4",
        x2: "31.6074",
        y2: "71.9977",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { offset: "0.272135", stopColor: "#34263B" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "0.658079", stopColor: "#13172C" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_1437_209",
        x1: "16.25",
        y1: "45.0473",
        x2: "23.0868",
        y2: "20.4962",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#F81E42" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#FA6981" })
    ))
  ));
}
export {
  c as RideIcSoatLight
};
